import React, { useEffect, useState } from 'react';

import slotIcon from '../static/img/icon-btn/slot-icon.png'; 
import crashGameIcon from '../static/img/icon-btn/crash-game-icon.png'; 
import liveGameIcon from '../static/img/icon-btn/live-game-icon.png';
import virtualIcon from '../static/img/icon-btn/virtual-icon.png';

import { useTranslation } from 'react-i18next';


import BingoIcon from '../static/img/icon-btn/bingo-icon.png';

import providerIcon1 from '../static/img/icon-provider/1x2gaming-icon.png';
import providerIcon2 from '../static/img/icon-provider/amatic-icon.png';
import providerIcon3 from '../static/img/icon-provider/absolute-live-gaming-icon.png';
import providerIcon4 from '../static/img/icon-provider/smartsoft-icon.png';

import Game from '../../../class/Game/Game';
import AuthService from '../../../class/services/AuthService';
import Games from '../../../class/Game_copy/Game';

import {openGameModal} from '../modal/modal_game';


const cmsUrl = process.env.REACT_APP_CMS_URL_ASSETS;


// Компонент картки гри
const CasinoGameCard = ({ imageSrc, providerIcon, providerName, gameName, gameId, isLogged, onOpenLogin, category_id }) => {
  const handleGameClick = () => {
    if (!isLogged) {
      onOpenLogin(); // Відкриває модалку входу
    } else {
      openGameModal(gameId, category_id); // Відкриває гру
    }
  };

  return (
    <div className="HomeSectionCasinoGames_game" onClick={handleGameClick} style={{ cursor: 'pointer' }}>
      <div className="CasinoGameCard_root">
        <div className="CasinoGamePreview_root">
          <div className="CasinoGamePreview_gradient"></div>
          <img className="ResponsivePicture_img CasinoGamePreview_image" src={imageSrc} alt={gameName} loading="lazy" />
        </div>
        <div className="CasinoGameCard_info CasinoGameCard_withProvider">
          <div className="CasinoGameCard_provider">
            <img alt={providerName} src={providerIcon} className="CasinoGameCard_icon" />
            <p className="CasinoGameCard_name">{providerName}</p>
          </div>
          <p className="CasinoGameCard_gameName">{gameName}</p>
        </div>
      </div>
    </div>
  );
};


const linksArray = [
  "https://storage.googleapis.com/camasy-images/casino/pragmatic__623355ffccb63.png",
  "https://storage.googleapis.com/camasy-images/casino/pragmatic__play__live__627e164c5c13d.jpeg",
  "https://storage.googleapis.com/camasy-images/casino/spribe__theear__629f71c1a62da.png",
  "https://storage.googleapis.com/camasy-images/casino/evoplay__theear__631afe94112d0.png",
  "https://storage.googleapis.com/camasy-images/casino/redrake__theear__624574edbac75.png",
  "https://storage.googleapis.com/camasy-images/casino/spribe__theear__628f7991b07e8.png",
  "https://storage.googleapis.com/camasy-images/casino/spribe__theear__629f768cb50fb.png",
  "https://storage.googleapis.com/camasy-images/casino/habanero__6245745b3e243.png",
  "https://content.stargame.solutions/api/game/icon2/1646",
  "https://content.stargame.solutions/api/game/icon2/1467"
];


function getRandomLink() {
  const randomIndex = Math.floor(Math.random() * linksArray.length);
  return linksArray[randomIndex];
}

const LoaderBox = ({t}) => (
  <div className="HomeSectionCasinoGames_game">
    <div className="CasinoGameCard_root">
      <div className="CasinoGamePreview_root">
        <div className="CasinoGamePreview_gradient"></div>
        <img
          className="ResponsivePicture_img CasinoGamePreview_image"
          style={{ filter: 'blur(8px)' }}
          src={getRandomLink()}
          alt="Loading..."
        />
      </div>
      <div className="CasinoGameCard_info CasinoGameCard_withProvider">
        <div className="CasinoGameCard_provider" style={{ filter: 'blur(2px)' }}>
          <img
            alt="Loading..."
            src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAFAAAABQCAYAAACOEfKtAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAA"
            className="CasinoGameCard_icon"
            style={{ filter: 'blur(2px)' }}
          />
          <p className="CasinoGameCard_name">{t('loading')}...</p>
        </div>
      </div>
    </div>
  </div>
);




// Основний компонент вибору ігор
const HomeGameSelection = ({ limit, selection_name, category_id, isLogged, onOpenLogin,custom_class,class_col }) => {
  const [games, setGames] = useState([]);
  const [categoryIcon, setCategoryIcon] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  const {t} = useTranslation();


  //setup selection icon base on category
  useEffect(() => {
    switch (category_id) {
      case "casino":
        setCategoryIcon("/assets/img/icon-btn/slot-icon.png");
        break;
      case "casino-live":
        setCategoryIcon("/assets/img/icon-btn/live-game-icon.png");
        break;
      case "crash-game":
        setCategoryIcon("/assets/img/icon-btn/crash-game-icon.png");
        break;
      case "bingo":
        setCategoryIcon("/assets/img/icon-btn/bingo-icon.png");
        break;   
      case "virtual":
        setCategoryIcon("/assets/img/icon-btn/virtual-icon.png");
        break;     
      default:
        setCategoryIcon(null);
    }
  }, [category_id]);
  

  useEffect(() => {
    const fetchGames = async () => {
      try {
        const userId = AuthService.getCustom('user_id') || '';

        const response = await Games.getHomeGames(userId,category_id,limit,1);
        // if (!response.status) throw new Error('Network error');
        // console.log("DATA: ");
        // console.log(response);
        if (response.status === 'ok') {
          const { games_list, next_page } = response.params;

          let baseGames = [];
          const existingIds = new Set();
  
          baseGames = games_list.map(game => {
            existingIds.add(game.id); 
            return {
              id: game.id,
              imageSrc: game.thumbnail,
              providerIcon: getProviderIcon(game.provider_slug),
              providerName: game.nome_provider,
              gameName: game.name,//name,
            };
          });
    
          setGames(baseGames);

        } else {
          console.error('API error:', response);
        }
        

        // 1XPLANET THING
        // const baseResponse = await Game.getGames(userId, category_id, limit, 1);  // category id è una stringa
  
        // let baseGames = [];
        // const existingIds = new Set();
  
        // if (baseResponse && Array.isArray(baseResponse.data)) {
        //   baseGames = baseResponse.data.map(game => {
        //     existingIds.add(game.game_id); 
        //     return {
        //       id: game.game_id,
        //       imageSrc: game.game_img,
        //       providerIcon: getProviderIcon(game.provider_slug),
        //       providerName: game.provider_name,
        //       gameName: game.game_name,//name,
        //     };
        //   });
        // }
  
        // setGames(baseGames);
        // setIsLoading(false);
      } catch (error) {
        console.error(`${t('Error_fetching_games')}:`, error);
      } finally {
        setIsLoading(false);
      }
    };
  
    fetchGames();
  }, [limit, category_id]);
  



 

  const getProviderIcon = (providerslug) => {
    return `${cmsUrl}static-assets/providers/${providerslug}.png`;
  };


  return (

    <div className={class_col || 'col-6'}>
      <div className={`body main-layout-item ColumnSection_list ${custom_class}`}>
        <div className="Home_root">
          <div className="Home_games">
            <div className="Home_header">

              <div className="HomeSection_header">
                <img alt="Slot Icon" src={categoryIcon} style={{filter:"invert(1)"}} className="HomeSection_icon" />
                <div className="HomeSection_label">{selection_name}</div>
                <div className="HomeSection_right">
                  <div className="HomeSection_headerLink">
                    <a href={`/${category_id}`}>{t('All')}</a>
                  </div>
                  <div className="HomeSection_caption"><strong> {t('Games')}</strong></div>
                </div>
              </div>

          
            </div>
            <div className="HomeSectionCasinoGames_list" style={ {minHeight : "163px"}}>
            {isLoading ? (
                
              <>
                <LoaderBox t={t}/>
                <LoaderBox t={t}/>
                <LoaderBox t={t}/>
                <LoaderBox t={t}/>
              </>
              ) : (
                
              games.map((game, index) => (
                <CasinoGameCard
                  key={index}
                  imageSrc={game.imageSrc}
                  providerIcon={game.providerIcon}
                  providerName={game.providerName}
                  gameName={game.gameName}
                  gameId={game.id}
                  isLogged={isLogged}
                  onOpenLogin={onOpenLogin}
                  category_id={category_id}
                />
              ))
            )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};


export default HomeGameSelection;
